const headerTopButton = () => {
    const headerTop = document.querySelector('.header-top');

    if (headerTop && !window.isMobile) {

        const headerTopBtn = document.querySelector('.header-top__button');
        const headerBtn = document.querySelector('.header__button');

        const showHeaderBtn = () => {
            if (headerTopBtn && headerBtn) {
                const headerTopHeight = headerTop.clientHeight;
                const isBtnActive = headerBtn.getBoundingClientRect().top - headerTopHeight <= 0;
                headerTopBtn.classList.toggle('header-top__button_active', isBtnActive);
            }
        };

        const headerTopBg = () => {
            headerTop.classList.toggle('header-top_bg-transparent', window.scrollY === 0);
        };

        // Изначально вызываем функции
        showHeaderBtn();
        headerTopBg();

        // Обработчик события scroll с использованием requestAnimationFrame для производительности
        let isScrolling = false;
        const onScroll = () => {
            if (!isScrolling) {
                isScrolling = true;
                requestAnimationFrame(() => {
                    showHeaderBtn();
                    headerTopBg();
                    isScrolling = false;
                });
            }
        };

        document.addEventListener('scroll', onScroll);
    }
};

export default headerTopButton;
